import type { Match } from '@shared/types';
import { PlayerPanel } from './PlayerPanel';
import { TableVisualization } from './TableVisualization';
import './MatchBoard.css';

interface MatchBoardProps {
  match: Match;
}

export function MatchBoard({ match }: MatchBoardProps) {
  const currentSet = match.sets[match.sets.length - 1];
  const setsWonA = match.sets.filter((s) => s.winner === 'sideA').length;
  const setsWonB = match.sets.filter((s) => s.winner === 'sideB').length;

  // Determine who is serving based on total points in current set
  // In table tennis, service changes every 2 points, but at 10-10, it alternates every point
  const totalPoints = currentSet.scoreA + currentSet.scoreB;
  const isDeuce = currentSet.scoreA >= 10 && currentSet.scoreB >= 10;
  const servingChanges = isDeuce ? 1 : 2;
  const isPlayerAServing = Math.floor(totalPoints / servingChanges) % 2 === 0;

  return (
    <div className="match-board">
      <div className="match-board__players">
        <PlayerPanel
          player={match.players.sideA}
          side="sideA"
          currentSetScore={currentSet.scoreA}
          setsWon={setsWonA}
          isServing={isPlayerAServing && match.status === 'in_progress'}
          isWinner={match.winner === 'sideA'}
        />

        <div className="match-board__center">
          <TableVisualization />
          
          <div className="match-info">
            <div className="match-info__item">
              <span className="match-info__label">Set Atual</span>
              <span className="match-info__value">{currentSet.index + 1}</span>
            </div>
            <div className="match-info__item">
              <span className="match-info__label">Melhor de</span>
              <span className="match-info__value">{match.config.bestOf}</span>
            </div>
          </div>
        </div>

        <PlayerPanel
          player={match.players.sideB}
          side="sideB"
          currentSetScore={currentSet.scoreB}
          setsWon={setsWonB}
          isServing={!isPlayerAServing && match.status === 'in_progress'}
          isWinner={match.winner === 'sideB'}
        />
      </div>
    </div>
  );
}
